<script>
import { VTextField } from 'vuetify/lib/components';
import AutoNumeric from 'autonumeric';
import {Separator} from "@/general/custom-types/CustomTypes";

export default {
  extends: VTextField,
  props: {
    allowDecimalPadding: { type: Boolean, default: true },
    decimalPlaces: { type: [Number, String], default: 5 },
    emptyInputBehavior: {
      type: [Number, String],
      default: "null"
    },
    outlined: {
      type: Boolean,
      default: true
    },
    shaped: {
      type: Boolean,
      default: true
    },
    minimumValue: {
      type: Number,
      default: 0
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    digitGroupSeparator: {
      type: String,
      default: Separator.NoSeparator
    },
    anOptions: {
      // autonumeric options (see doc)
      type: Object,
      required: false,
      default() {
        return {
          // TODO: Jest potrzebne, bo czesc numberfieldow przelicza sie automatycznie. Gdy podczas obliczen przekrocza max wartosc dla autonumericjs, to komponent wywala sie
          maximumValue: 100000000000,
          emptyInputBehavior: this.emptyInputBehavior,
          decimalPlaces: this.decimalPlaces,
          allowDecimalPadding: this.allowDecimalPadding,
          decimalCharacter: ",",
          digitGroupSeparator: this.digitGroupSeparator,
          minimumValue: this.minimumValue,
          modifyValueOnWheel: false,
        };
      }
    }
  },
  data() {
    return {
      anElement: null, // autonumeric instance
      changedByInput: false // Flag to know if the value is changed by user input
    };
  },
  mounted() {
    // Create the AutoNumeric instance on the VTextField input element
    this.anElement = new AutoNumeric(this.$refs.input, this.anOptions);
    // Set the AutoNumeric  default value
    this.anElement.set(this.value);

  },
  methods: {
    onInput() {
      // User has changed the input
      this.changedByInput = true; // set the flag to true
      this.updateVModel(); // emit v-model
    },
    updateVModel() {
      // emit raw value
      if (this.anElement !== null) {
        this.$emit("input", this.anElement.getNumber());
      }
    },
    genInput() {
      const listeners = Object.assign({}, this.listeners$);
      delete listeners.change;
      const element = this.$createElement("input", {
        class: {},
        style: {},
        attrs: {
          ...this.attrs$,
          autofocus: this.autofocus,
          disabled: this.disabled,
          id: this.computedId,
          placeholder: this.placeholder,
          readonly: this.readonly,
          type: this.type,
          label: this.label,
          hideDetails: this.hideDetails
        },
        on: {
          blur: this.onBlur,
          input: this.onInput,
          focus: this.onFocus,
          keydown: this.onKeyDown,
          "autoNumeric:formatted": () => {
            this.changedByInput = false; // Remove the flag when autonumeric finish formatting
          }
        },
        ref: "input"
      });
      return element;
    }
  },
  watch: {
    value(newVal) {
      try {
        // Check if the last v-model update is fired by the input
        if (!this.changedByInput) {
          this.anElement.set(this.value); // Set the AutoNumeric raw value
        }
      } catch (e) {}
    }
  }
};
</script>
